<script lang="ts">
    import { link } from 'svelte-spa-router'
    import { t } from '../lib/i18n/t';

    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    $: activity = serviceProvider.activityService.getActivityById(dataProvider.activityId)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
    $: group = activity ? serviceProvider.groupService.getGroupById(activity.skupina) : null

    export let activitySection = false
    export let dateTimeSection = false
    export let contactSection = false
</script>
<nav class="bno-container bno-section-menu">
    <div class="bno-container__content">
        <ul class="bno-section-menu__items">
            <li class="bno-section-menu__item" class:bno-section-menu__item--active={activitySection}>
                <span aria-hidden="true"></span>
                {#if dateTimeSection || contactSection}
                    {#if group}
                        <a href="/{t('page.skupina')}/{group.id}" class="bno-link" use:link>
                             {t('breadcrumb.predmetNavstevy')}
                        </a>
                    {:else}
                        <a href="/" class="bno-link" use:link>
                            {t('breadcrumb.predmetNavstevy')}
                        </a>
                    {/if}
                {:else}
                    <span>{t('breadcrumb.predmetNavstevy')}</span>
                {/if}
            </li>
            <li class="bno-section-menu__item" class:bno-section-menu__item--active={dateTimeSection}>
                <span aria-hidden="true"></span>
                {#if contactSection && activity}
                    <a href="/{t('page.sluzba')}/{activity.id}" class="bno-link" use:link>
                        {t('breadcrumb.termin')}
                    </a>
                {:else}
                    <span>{t('breadcrumb.termin')}</span>
                {/if}
            </li>
            <li class="bno-section-menu__item" class:bno-section-menu__item--active={contactSection}>
                <span aria-hidden="true"></span>
                <span>{t('breadcrumb.osobniInformace')}</span>
            </li>
        </ul>
    </div>
</nav>
